<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Section</h1>
                <v-btn to="/section/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Section
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
        >
            <v-col
                cols="12"
                md="5"
                align="center"
                justify="center"
            >
                <SectionEditForm />
            </v-col>
            <v-col
                cols="12"
                md="3"
            >
                <SectionStructure />
            </v-col>
        </v-row>

        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Section: {{ name }}
                </v-card-title>
                <v-card-text>
                    <p>Deleting this step is permanent and cannot be undone.</p>
                    <p>Click "DELETE SECTION" to proceed.</p>
                </v-card-text>
                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy"
                    >
                        Delete Section
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import SectionEditForm from './SectionEditForm';
import SectionStructure from './SectionStructure';
import { mapActions, mapMutations, mapState } from 'vuex';
import Overlay from '@/components/Overlay';

export default {
    components: { Overlay, SectionStructure, SectionEditForm },

    computed: {
        ...mapState('sectionEditor', ['steps', 'deleteModal', 'name'])
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'sectionEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            saveData: 'sectionEditor/saveData',
            destroyData: 'sectionEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
